module.exports = __webpack_public_path__ + "img/iconBG.053b4a32.png";